import {BehaviorSubject, catchError, finalize, Observable, of, shareReplay, Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BimForgeApiService} from "../bim-forge/bim-forge-api.service";
import {map} from "rxjs/operators";

export interface ThumbnailData {
  blob?: Blob,
  url?: string;

}

@Injectable({providedIn: 'root'})
export class BimModelThumbnailService {
  private thumbnailCache = new Map<string, { blob: Blob; url: string }>();
  private pendingRequests = new Map<string, Observable<ThumbnailData>>();

  constructor(private http: HttpClient, private bimForgeApiService: BimForgeApiService) {
  }

  private getKey(id: string, versionId: string): string {
    return `bimModel:${id}-versionId:${versionId}`;
  }

  public getThumbnail(modelId: string, versionId: string): Observable<ThumbnailData> {
    const key = this.getKey(modelId, versionId);

    if (this.thumbnailCache.has(key)) {
      const cachedData = this.thumbnailCache.get(key)!;
      return of(cachedData);
    }

    //we  Check if there's an ongoing request for the same thumbnail
    if (this.pendingRequests.has(key)) {
      return this.pendingRequests.get(key)!;
    }

    const thumbnail$ = this.bimForgeApiService.getThumbnail(modelId, versionId).pipe(
      map(arrayBuffer => {
        const blob = new Blob([arrayBuffer], {type: 'image/png'});
        const url = URL.createObjectURL(blob);
        this.thumbnailCache.set(key, {blob, url});
        return {blob, url} as ThumbnailData;
      }),
      finalize(() => {
        this.pendingRequests.delete(key);
      }),
      // Share the observable among multiple subscribers and replay the last emitted value
      shareReplay(1)
    );

    this.pendingRequests.set(key, thumbnail$);
    return thumbnail$;
  }

  ngOnDestroy() {
    this.clearCache();
  }

  public clearCache() {
    this.thumbnailCache.forEach(({url}) => URL.revokeObjectURL(url));
    this.thumbnailCache.clear();
  }

}

